'use client';

import { faGift } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import BlackFridayModal from './black-friday-modal';

const BlackFridayBanner = () => {
  const [isOpen, setOpen] = useState(false);

  const toggle = () => {
    setOpen((o) => !o);
  };

  return (
    <>
      <div className="bg-black text-white bg-gradient-to-br">
        <div className="px-2 py-2 flex flex-row justify-between items-baseline mx-auto max-w-lg gap-2">
          <div className="w-full flex gap-3 justify-center">
            <p className="hidden sm:block">
              <FontAwesomeIcon icon={faGift} />
            </p>

            <p className="font-extrabold tracking-wide">
              Black Friday deals are here
            </p>
          </div>

          <button className="btn btn-white btn-sm rounded-full sm:w-32" onClick={toggle}>
            Get deals
          </button>
        </div>
      </div>

      {isOpen ? (
        <BlackFridayModal toggle={toggle} />
      ) : null}
    </>
  );
};

export default BlackFridayBanner;
